/* eslint-disable no-useless-escape */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { I18n } from 'react-redux-i18n';
// import InputMask from 'react-input-mask';
import moment from 'moment-timezone';
import ValidatorsHelper from '../../../helpers/validators';

class CheckoutPaymentBankSlip extends React.PureComponent {
  constructor() {
    super();

    this.state = {
      cnpjError: '',
      cnpj: '',
      phone: '',
      birthDate: '',
    };
  }

  // componentDidMount = () => {
  //   if (this.props.paymentService === 'pagseguro') {
  //     this.checkPersonalData();
  //   }
  // }

  setValue = async (key, value) => {
    if (key === 'birthDate') {
      if (!moment(value).isAfter(moment(new Date()).format('YYYY-MM-DD'))) {
        this.setState({
          birthDateError: false,
          [key]: value,
        });
      } else {
        this.setState({
          birthDateError: true,
          [key]: value,
        });
      }
    } else {
      this.setState({
        [`${key}Error`]: '',
        [`${key}Changed`]: true,
        [key]: value,
      });
    }
    if (key === 'cnpj') this.onChangedCnpj(value);
  }

  formatCpnjCpf = (value, opcoRegisterCPF) => {
    if (opcoRegisterCPF && value.length <= 11) {
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '\$1.\$2.\$3\-\$4');
    }

    return value.substring(0, 14).replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '\$1.\$2.\$3\/\$4\-\$5');
  }

  removeMarkCnpjCpf = value => value.replace(/(\.|\/|\-)/g, '');

  onChangedCnpj = (value) => {
    const type = value.length <= 11 ? 'cpf' : 'cnpj';

    if (type === 'cnpj' && ValidatorsHelper.validarCNPJ(value)) {
      this.props.setDocument({ value, type });
      return;
    }
    if (type === 'cpf' && ValidatorsHelper.validarCPF(value)) {
      this.props.setDocument({ value, type });
      return;
    }

    this.props.setDocument({ value: '', type: '' });
  }

  onBlurCnpj = () => {
    const { cnpj } = this.state;
    const type = cnpj.length <= 11 ? 'cpf' : 'cnpj';
    const value = cnpj;

    if (!value.trim()) return;

    if (type === 'cnpj' && !ValidatorsHelper.validarCNPJ(value)) {
      this.setState({ cnpjError: I18n.t('invalidCNPJ') });
      this.props.setDocument({ value: '', type: '' });
      return;
    }
    if (type === 'cpf' && !ValidatorsHelper.validarCPF(value)) {
      this.setState({ cnpjError: I18n.t('invalidCPF') });
      this.props.setDocument({ value: '', type: '' });
      return;
    }

    this.props.setDocument({ value, type });
  }

  checkData = async (type) => {
    if (this.props.paymentService === 'pagseguro') {
      if (this.state.phone.length > 13) {
        this.props.setData({ phone: this.state.phone, birthDate: this.state.birthDate });
        this.props.setPayment(type);
      } else {
        await this.setState({
          phoneError: I18n.t('incompletePhoneError'),
        });
      }
    } else {
      this.props.setPayment(type);
    }
  }

  checkPersonalData = () => {
    if (this.props.personalData && this.props.personalData.birthDate && !this.state.birthDate) {
      this.setValue('birthDate', this.props.personalData.birthDate);
    }
    if (this.props.personalData && this.props.personalData.phone && !this.state.phone) {
      this.setValue('phone', this.props.personalData.phone);
    }
  }

  render() {
    const {
      document,
      setPayment,
    } = this.props;
    const {
      /* phone, birthDate, phoneError, birthDateError, */ cnpjError, cnpj,
    } = this.state;

    const type = 'bank_slip';

    if (this.props.paymentService === 'pagseguro') {
      return (
        <div className="row">
          {/* <div style={{ flex: 1 }}>
            <div style={{ flex: 1 }}>
              <div className="basket-form__group">
                <label className="lbl">
                  {I18n.t('phone2')}
                  <InputMask
                    tabIndex="-1"
                    className="fld"
                    type="text"
                    mask={phone.length > 14 ? '(99) 9 9999-9999' : '(99) 9999-99999'}
                    maskChar={null}
                    value={phone}
                    onChange={e => this.setValue('phone', e.target.value)}
                    required
                  />
                </label>
                {phoneError ? (
                  <div style={{ height: 50 }}>
                    <p className="error-msg">{phoneError}</p>
                  </div>
                ) : ''}
              </div>
            </div>
            <div style={{ flex: 1 }}>
              <div className="basket-form__group">
                <label className="lbl">
                  {I18n.t('birthDate2')}
                  <input
                    tabIndex="-1"
                    className="fld"
                    type="date"
                    value={birthDate}
                    onChange={e => this.setValue('birthDate', e.target.value)}
                    required
                  />
                </label>
                {birthDateError ? (
                  <div style={{ height: 50 }}>
                    <p className="error-msg">{I18n.t('errorDateReported')}</p>
                  </div>
                ) : ''}
              </div>
            </div>
          </div> */}
          <div style={{ flex: 1, paddingTop: 20 /* paddingLeft: 36 */ }}>
            <div className="col-6">
              <p className="invoice-p">{`${I18n.t('bankSlipText1')} ${I18n.t('bankSlipText2')}`}</p>
              <p className="invoice-p">{I18n.t('bankSlipText3')}</p>
              <br />
              <p className="invoice-p" style={{ fontWeight: 'bolder' }}>{I18n.t('bankSlipText4')}</p>
              <br />
              <div style={{ marginRight: 'auto', display: 'block' }}>
                <button
                  type="button"
                  className="button-action btn btn-secondary"
                  // disabled={(birthDateError === false) ? birthDateError : true}
                  // onClick={() => this.checkData(type)}
                  onClick={() => setPayment(type)}
                >
                  {I18n.t('payWithBankSlip')}
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="row">
        <div style={{ flex: 1 }}>
          <div className="basket-form__group">
            <label className="lbl">
              {I18n.t('loginNewRegisterCnpjCpf')}
              <input
                tabIndex="-1"
                className="fld"
                type="text"
                value={this.formatCpnjCpf(cnpj, true)}
                onChange={e => this.setValue('cnpj', this.removeMarkCnpjCpf(e.target.value))}
                onBlur={this.onBlurCnpj}
                required
              />
            </label>
            <div style={{ height: 50 }}>
              {cnpjError ? <p className="error-msg">{cnpjError}</p> : ''}
            </div>
          </div>
        </div>
        <div style={{ flex: 2, paddingTop: 10, paddingLeft: 36 }}>
          <div className="col-6">
            <p className="invoice-p">{I18n.t('bankSlipText1')}</p>
            <p className="invoice-p">{I18n.t('bankSlipText2')}</p>
            <p className="invoice-p">{I18n.t('bankSlipText3')}</p>
            <p className="invoice-p" style={{ height: '10px' }} />
            <button
              type="button"
              className="button-action btn btn-secondary"
              disabled={!ValidatorsHelper.validDocument(document.type, document.value)}
              onClick={() => setPayment(type, { document })}
            >
              {I18n.t('payWithBankSlip')}
            </button>
          </div>
        </div>
      </div>
    );
  }
}


export default CheckoutPaymentBankSlip;
